<agr-page-sidesheet
  [pageTitle]="'activeIngredientSettings' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'addActiveIngredientSetting' | translate"
  (primaryAction)="addActiveIngredientSetting()"
>
  <ng-container actions>
    @if (isMobile()) {
      <button mat-icon-button (click)="setSearch()" data-test="activeIngredientSetting-filter">
        <mat-icon>search</mat-icon>
      </button>
    }
  </ng-container>
  <ng-container sidesheet>
    <mat-toolbar class="mat-toolbar-transparent">
      <mat-icon>filter_list</mat-icon>
    </mat-toolbar>
    <div class="wrapper--spacing-horizontal">
      <mat-form-field class="full-width-field">
        <mat-label>{{ 'ingredientName' | translate }}</mat-label>
        <input
          id="active-ingredient-settings-filter-name"
          matInput
          [formControl]="filterNameControl"
          [placeholder]="'ingredientName' | translate"
          [attr.aria-label]="'ingredientName' | translate"
          data-test="activeIngredientSetting-filter-name"
        />
      </mat-form-field>
      <mat-form-field class="full-width-field">
        <mat-select
          [formControl]="filterYearControl"
          [placeholder]="'year' | translate"
          data-test="activeIngredientSetting-filter-year"
        >
          @for (year of availableCropYears; track year) {
            <mat-option [value]="year" data-test="overview-cropYear-options">
              {{ year }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="mat-button-row flex--justify-end">
        <button
          mat-button
          (click)="resetFilter()"
          [disabled]="filterEnabled() === false"
          data-test="filter-reset"
        >
          <mat-icon>clear</mat-icon> {{ 'resetFilter' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
  <agr-notification-empty
    [isEmpty]="!activeIngredientSettings().length || !filteredActiveIngredientSettings().length"
    [emptyTitle]="'activeIngredientSettingsEmpty' | translate"
    [emptyDescription]="
      (filterEnabled() ? 'noActiveIngredientSettingsFound' : 'noActiveIngredientSettings')
        | translate
    "
    emptyActionIcon="clear"
    [emptyActionText]="'resetFilter' | translate"
    [showEmptyAction]="filterEnabled()"
    (emptyAction)="resetFilter()"
    class="notification-wrapper"
  >
    @if (activeIngredientSettings().length && pagedActiveIngredientSettings().length) {
      <div class="container">
        <agr-table [config]="tableConfig" data-test="activeIngredientSettings-table"></agr-table>
        <mat-paginator
          [pageSize]="page().pageSize ?? pageSize"
          [pageSizeOptions]="[10, 25, 50]"
          [length]="filteredActiveIngredientSettings().length"
          (page)="onPage($event)"
        ></mat-paginator>
      </div>
    }
  </agr-notification-empty>
</agr-page-sidesheet>
